import { render, staticRenderFns } from "./password-qna.vue?vue&type=template&id=c788bcb0&"
import script from "./password-qna.vue?vue&type=script&lang=js&"
export * from "./password-qna.vue?vue&type=script&lang=js&"
import style0 from "./password-qna.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports